// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticlesByDigitalAssetIdRequestModel from '../../model/get-shop-articles-by-digital-asset-id-request-model';
import GetShopArticlesByDigitalAssetIdRequestDTO from '../dto/get-shop-articles-by-digital-asset-id-request-dto';
import dtoSchema from '../schemas/get-shop-articles-by-digital-asset-id-request-schema';

export default abstract class GetShopArticlesByDigitalAssetIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticlesByDigitalAssetIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.currentPage = data.currentPage;
      this.pageSize = data.pageSize;
      this.includeCount = data.includeCount;
      this.noPaging = data.noPaging;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int32}
  */
  currentPage?: number;
  /**
  * @type {int32}
  */
  pageSize?: number;
  /**
  */
  includeCount?: boolean;
  /**
  */
  noPaging?: boolean;

  static toModel(dto: DeepPartial<GetShopArticlesByDigitalAssetIdRequestDTO>): GetShopArticlesByDigitalAssetIdRequestModel;
  static toModel(dto: DeepPartial<GetShopArticlesByDigitalAssetIdRequestDTO> | undefined | null): GetShopArticlesByDigitalAssetIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticlesByDigitalAssetIdRequestDTO> | undefined | null): GetShopArticlesByDigitalAssetIdRequestModel | undefined {
    return dto ? new GetShopArticlesByDigitalAssetIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticlesByDigitalAssetIdRequestModel> | GetShopArticlesByDigitalAssetIdRequestModel): GetShopArticlesByDigitalAssetIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      currentPage: unwrapped.currentPage,
      pageSize: unwrapped.pageSize,
      includeCount: unwrapped.includeCount,
      noPaging: unwrapped.noPaging,
    } as GetShopArticlesByDigitalAssetIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticlesByDigitalAssetIdRequestModel, can not map to GetShopArticlesByDigitalAssetIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
